import AgoraPlayerComponent from "./AgoraPlayerComponent";

export default AgoraPlayerComponent;